module.exports = __webpack_public_path__ + "img/small-6.50c67598.webp";